import { GetStartedPage } from "../../../../src/components/get-started";
import * as React from 'react';
export default {
  GetStartedPage,
  React
};